import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('temperature_log')
export class TemperatureLog {
    @PrimaryGeneratedColumn("increment", { name: 'temp_log_id' })
    tempLogId: number;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "load_status"
    })
    loadStatus: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "uid"
    })
    uid: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "dept_name"
    })
    deptName: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "dept_code"
    })
    deptCode: string;

    @Column("int", {
        nullable: false,
        name: "unit_id"
    })
    unitId:number

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "module"
    })
    module: string;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "sub_module"
    })
    subModule: string;

    @Column("datetime", {
        name: "date"
    })
    date: Date;

    @Column("tinyint", {
        nullable: false,
        name: "day"
    })
    day: number;

    @Column("tinyint", {
        nullable: false,
        name: "month"
    })
    month: number;

    @Column("tinyint", {
        nullable: false,
        name: "hour"
    })
    hour: number;

    @Column("tinyint", {
        nullable: false,
        name: "minutes"
    })
    minutes: number;

    @Column("smallint", {
        nullable: false,
        name: "temperature"
    })
    temperature: number;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "uom"
    })
    uom: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}